module.exports = __webpack_public_path__ + "static/img/icon-setting1.33865c86.svg";